import { AxiosInstance } from "axios";
import { ICore } from "./interfaces";

export function getSaveCommunicationPreferencesBuilder(
  apiClient: AxiosInstance
) {
  return async function saveCommunicationPreferences(
    key: ICore.CommunicationPermissionTypes,
    value: string | number | boolean
  ): Promise<ICore.ICommPermission> {
    const response = await apiClient.post(
      `/accounts/notification-permissions/`,
      { key, value }
    );
    return response.data;
  };
}
